import React from 'react';

class ChartErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }

    static getDerivedStateFromError(error) {
        // Actualiza el state para mostrar la UI de error
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        // Puedes registrar el error en un servicio de logging aquí
        console.error('Chart Error Boundary caught an error:', error, errorInfo);
        this.setState({
            error: error,
            errorInfo: errorInfo
        });
    }

    handleRetry = () => {
        this.setState({ hasError: false, error: null, errorInfo: null });
    };

    render() {
        if (this.state.hasError) {
            // UI de respaldo
            return (
                <div className="chart-error-container" style={{
                    padding: '20px',
                    textAlign: 'center',
                    backgroundColor: '#f8f9fa',
                    border: '1px solid #dee2e6',
                    borderRadius: '8px',
                    margin: '10px 0',
                    minHeight: '200px',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}>
                    <div style={{ marginBottom: '15px' }}>
                        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#6c757d" strokeWidth="2">
                            <circle cx="12" cy="12" r="10"/>
                            <line x1="15" y1="9" x2="9" y2="15"/>
                            <line x1="9" y1="9" x2="15" y2="15"/>
                        </svg>
                    </div>
                    <h4 style={{ color: '#6c757d', marginBottom: '10px', fontSize: '16px' }}>
                        Error al cargar el gráfico
                    </h4>
                    <p style={{ color: '#6c757d', fontSize: '14px', marginBottom: '15px' }}>
                        No se pudieron cargar los datos del gráfico. Por favor, intenta recargar.
                    </p>
                    <div style={{ display: 'flex', gap: '10px' }}>
                        <button 
                            onClick={this.handleRetry}
                            style={{
                                backgroundColor: '#007bff',
                                color: 'white',
                                border: 'none',
                                padding: '8px 16px',
                                borderRadius: '4px',
                                cursor: 'pointer',
                                fontSize: '14px'
                            }}
                        >
                            Reintentar
                        </button>
                        <button 
                            onClick={() => window.location.reload()} 
                            style={{
                                backgroundColor: '#6c757d',
                                color: 'white',
                                border: 'none',
                                padding: '8px 16px',
                                borderRadius: '4px',
                                cursor: 'pointer',
                                fontSize: '14px'
                            }}
                        >
                            Recargar página
                        </button>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ChartErrorBoundary;
